import { createContext } from 'react';

export const initialState = {
  modules: [],
};
const ReferencialContext = createContext(initialState);

export const { Provider } = ReferencialContext;
export default ReferencialContext;
